import React from 'react'
import { Link } from 'react-router-dom'
import RaisedButton from 'material-ui-legacy/RaisedButton'

const LinkButton = props => {
  const { url, style, label, icon, ...otherProps } = props
  return (
    <Link to={url}>
      <RaisedButton
        style={style || { margin: '5px' }}
        label={label || 'Link'}
        icon={icon}
        labelPosition="after"
        primary={true}
        {...otherProps}
      />
    </Link>
  )
}

export default LinkButton



// WEBPACK FOOTER //
// ./src/components/UI/LinkButton.jsx